<div class="menu-header">
  <img src="/NTSLogo1.png" alt="Dutch Transplant Foundation" class="logo" />
  <h1>NTS CrossoverPlus</h1>
</div>
<mat-nav-list>
  <a *ngIf="canReadDashboard" mat-list-item href="/">
    <mat-icon mat-list-icon>home</mat-icon>
    Dashboard
  </a>
  <a *ngIf="isNewsItemAdmin" mat-list-item href="/newsitems">
    <mat-icon mat-list-icon>event_note</mat-icon>
    News Items
  </a>
  <mat-divider></mat-divider>
  <!-- Show "Current Match Run" if matchruns exist -->
  <a *ngIf="hasMatchingPeriod && hasMatchruns && latestMatchrun" mat-list-item [href]="'/matchrun/' + currentMatchingPeriodId + '/' + latestMatchrun">
    <mat-icon mat-list-icon>autorenew</mat-icon>
    Current Match Run
  </a>
  <!-- Show "Start Match Run" if no matchruns exist yet but user has permission -->
  <a *ngIf="hasMatchingPeriod && !hasMatchruns && canStartMatchrun" mat-list-item href="/matchstart">
    <mat-icon mat-list-icon>play_arrow</mat-icon>
    Start Match Run
  </a>
  <a *ngIf="canReadTimeline" mat-list-item [href]="'/timeline/' + currentMatchingPeriodId">
    <mat-icon mat-list-icon>timeline</mat-icon>
    Timeline
  </a>
  <a *ngIf="canAccessCenters" mat-list-item href="/centers">
    <mat-icon mat-list-icon>business</mat-icon>
    Centers
  </a>
  <a *ngIf="canReadCrossmatches" mat-list-item href="/crossmatch">
    <mat-icon mat-list-icon>local_hospital</mat-icon>
    Crossmatches
  </a>
  <a *ngIf="canReadCrossmatches" mat-list-item href="/combination">
    <mat-icon mat-list-icon>cancel</mat-icon>
    Excluded combinations
  </a>
  <mat-divider></mat-divider>
  <a *ngIf="canReadParticipants" mat-list-item href="/participants">
    <mat-icon mat-list-icon>manage_accounts</mat-icon>
    Participants
  </a>
  <a *ngIf="canReadApprovals" mat-list-item href="/approvals">
    <mat-icon mat-list-icon>approval_delegation </mat-icon>
    Approval requests
  </a>
  <a *ngIf="canReadHistoricalParticipants" mat-list-item href="/historical">
    <mat-icon mat-list-icon>history</mat-icon>
    Historical Participants
  </a>
  <a *ngIf="canAccessEnisSyncLog" mat-list-item href="/enissync-log">
    <mat-icon mat-list-icon>sync</mat-icon>
    Enissync-logs
  </a>
  <!-- <a *ngIf="canReadPairs" mat-list-item href="/pairs">
    <mat-icon mat-list-icon>group</mat-icon>
    Pairs
  </a> -->

  <!--
    <a mat-list-item routerLink="/auth">
        <mat-icon mat-list-icon>vpn_key</mat-icon>
        Permissions
    </a>
    <a mat-list-item routerLink="/user">
        <mat-icon mat-list-icon>person_add</mat-icon>
        User Administration
    </a>

    <mat-divider></mat-divider>
    <a mat-list-item routerLink="/data-admin">
        <mat-icon mat-list-icon>settings_system_daydream</mat-icon>
        Data Administration
    </a>
    <a mat-list-item>
        <mat-icon mat-list-icon>info</mat-icon>
        About
    </a> -->
</mat-nav-list>
<div class="fill"></div>
<div class="footer">
  <mat-divider></mat-divider>
  <app-matchingPeriod *ngIf="canReadMatchingPeriod" class="inner"></app-matchingPeriod>
  <mat-divider></mat-divider>
</div>